import { Converter } from '../types/converter';

export const linearChargeDensityConverter: Converter = {
  id: 'linearChargeDensity',
  name: 'Linear Charge Density Converter',
  icon: 'MinusSquare',
  categories: ['electricity'],
  units: [
    // Base SI unit
    { name: 'Coulomb/meter', symbol: 'C/m', factor: 1 },
    { name: 'Coulomb/centimeter', symbol: 'C/cm', factor: 100 },
    { name: 'Coulomb/inch', symbol: 'C/in', factor: 39.37007874 },
    
    // CGS units
    { name: 'Abcoulomb/meter', symbol: 'abC/m', factor: 10 },
    { name: 'Abcoulomb/centimeter', symbol: 'abC/cm', factor: 1000 },
    { name: 'Abcoulomb/inch', symbol: 'abC/in', factor: 393.7007874 }
  ]
};
